/* src/app/shared/menu-drop-button/menu-drop-button.component.css */
.dropdown-container {
  position: relative;
  display: inline-block;
}
.button-icon {
  margin-right: 0.5em;
}
.dropdown-list {
  position: fixed;
  top: 64px;
  right: 12px;
  left: auto;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  width: min(900px, calc(100vw - 24px));
  box-sizing: border-box;
  height: auto;
  max-height: calc(100vh - 80px);
  gap: 0;
  padding: 16px 20px;
  margin: 0;
  font-family: Outfit;
  font-size: 0.95rem;
  text-align: left;
  list-style: none;
  background: #f2f2f2;
  border: 1px solid #d0d8d6;
  border-radius: 12px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  animation: dropdownFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  color: #000;
  overflow-x: hidden;
  overflow-y: auto;
}
@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-12px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes dropdownFadeInCentered {
  from {
    opacity: 0;
    transform: translate(-50%, -12px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0) scale(1);
  }
}
@media (max-width: 1024px) {
  .dropdown-list {
    right: 12px;
    max-height: calc(100vh - 88px);
  }
}
.dropdown-list::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 32px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #000000;
  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.3));
}
@media (max-width: 600px) {
  .dropdown-list {
    top: 56px;
    width: calc(100vw - 16px);
    max-width: calc(100vw - 16px);
    max-height: calc(100vh - 70px);
    padding: 12px;
  }
}
.dropdown-item {
  padding: 0;
  columns: 3 220px;
  column-gap: 20px;
  font-family: Outfit;
  font-weight: 400;
  text-align: inherit;
  background: none;
  border: 0;
  cursor: default;
}
.dropdown-item > div {
  break-inside: avoid;
  padding-bottom: 8px;
}
.category-title {
  font-weight: 700;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #10B8AD;
  padding: 0 0 6px 0;
  margin: 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}
.category-title::before {
  content: "";
  width: 3px;
  height: 14px;
  background:
    linear-gradient(
      180deg,
      #10B8AD 0%,
      rgba(16, 184, 173, 0.3) 100%);
  border-radius: 2px;
}
.category-title::after {
  content: "";
  flex: 1;
  height: 1px;
  background:
    linear-gradient(
      90deg,
      rgba(16, 184, 173, 0.3) 0%,
      transparent 100%);
}
@media (max-width: 468px) {
  .dropdown-item {
    columns: 1;
  }
}
.menu-drop-button {
  display: flex;
  gap: 8px;
  padding: 6px 12px;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px;
  background: #f3f3f3;
  border: 1px solid #d0d8d6;
  font-family: Outfit;
  font-size: 0.95rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.menu-drop-button:hover {
  background: #e8e8e8;
  border-color: #bfbfbf;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}
.menu-drop-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.menu-drop-button i {
  transition: transform 0.3s ease;
}
.menu-drop-button[aria-expanded=true] i {
  transform: rotate(180deg);
}
.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #333;
  font-family: Outfit;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.menu-item:hover {
  background: rgba(0, 76, 74, 0.06);
  color: #004C4A;
}
.menu-item:active {
  background: rgba(0, 76, 74, 0.12);
}
.menu-item:focus-visible {
  outline: 2px solid #004C4A;
  outline-offset: 1px;
  box-shadow: 0 0 0 4px rgba(0, 76, 74, 0.1);
}
.menu-item-icon {
  font-size: 1.15rem;
  width: 22px;
  text-align: center;
  color: #888;
  flex-shrink: 0;
}
.menu-item:hover .menu-item-icon {
  color: #10B8AD;
}
.menu-item-active {
  background: rgba(16, 184, 173, 0.1);
  color: #004C4A;
  font-weight: 500;
}
.menu-item-active .menu-item-icon {
  color: #10B8AD;
}
body.dark-theme .dropdown-list {
  background: #1a1a1a;
  border-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3);
  color: #e5e5e5;
}
body.dark-theme .dropdown-list::before {
  border-bottom-color: #1a1a1a;
}
body.dark-theme .category-title {
  color: #10B8AD;
  border-bottom-color: rgba(16, 184, 173, 0.2);
}
body.dark-theme .dropdown-item:hover,
body.dark-theme .dropdown-item:focus-visible {
  background-color: rgba(16, 184, 173, 0.15);
  color: #ffffff;
}
body.dark-theme ppl-menu-button:hover {
  background: rgba(255, 255, 255, 0.1);
}
body.dark-theme ppl-menu-button:focus-visible {
  outline-color: #10B8AD;
  box-shadow: 0 0 0 4px rgba(16, 184, 173, 0.2);
}
/*# sourceMappingURL=menu-drop-button.component-TQPRIP6F.css.map */
